import * as types from './conclusions.types';
import * as constants from './conclusions.constants';
import { IConclusion, IConclusionSaveData } from '../../../resource/conclusion/conclusion.types';
import { ISession } from '../../../resource/session/session.types';
import { IUser } from '../../../resource/user/user.types';

export const storeConclusions = (conclusions: IConclusion['id'][]): types.IStoreConclusions => ({
  type: constants.STORE_CONCLUSIONS,
  payload: conclusions,
});

export const clearConclusions = (): types.IClearConclusions => ({
  type: constants.CLEAR_CONCLUSIONS,
});

export const showRecapValidationErrors = (showErrors: boolean): types.IShowRecapValidationErrors => ({
  type: constants.SHOW_RECAP_VALIDATION_ERRORS,
  payload: showErrors,
});

export const setupConclusions = (sessionId: ISession['id']): types.ISetupConclusions => ({
  type: constants.SETUP_CONCLUSIONS,
  payload: sessionId,
});

export const saveConclusion = (
  sessionId: ISession['id'],
  userId: IUser['id'],
  conclusionData: IConclusionSaveData,
): types.ISaveConclusion => ({
  type: constants.SAVE_CONCLUSION,
  payload: {
    sessionId,
    userId,
    conclusionData,
  },
});

export const deleteConclusion = (sessionId: ISession['id'], userId: IUser['id']): types.IDeleteConclusion => ({
  type: constants.DELETE_CONCLUSION,
  payload: {
    sessionId,
    userId,
  },
});

/*
export const deleteConclusion = (conclusionId: IConclusion['id']): types.IDeleteConclusion => ({
  type: constants.DELETE_CONCLUSION,
  payload: conclusionId,
});
*/
